import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
const routes = {
  path: "",
  component: () => import("../../../layouts/main/Main.vue"),
  children: [
    {
      path: "/registered-companies",
      name: "registered-companies",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        if (hasPermission) next();
        else next("/forbidden");
      },
      component: () =>
        import("./Company/CompaniesRegistered/CompaniesRegistered.vue")
    },
    {
      path: "/companies-in-approval",
      name: "companies-in-approval",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        if (hasPermission) next();
        else next("/forbidden");
      },
      component: () =>
        import("./Company/CompaniesInApproval/CompaniesInApproval.vue")
    },
    {
      path: "/company",
      name: "company",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        if (hasPermission) next();
        else next("/forbidden");
      },
      component: () => import("./Company/Company/Company.vue")
    },
    {
      path: "/Partnerships",
      name: "Partnerships",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        if (hasPermission) next();
        else next("/forbidden");
      },
      component: () => import("./Partnerships/PartnershipsForm/PartnershipsForm.vue")
    },
    {
      path: "/PartnershipsRegistered",
      name: "PartnershipsRegistered",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        if (hasPermission) next();
        else next("/forbidden");
      },
      component: () => import("./Partnerships/PartnershipsRegistered/PartnershipsRegistered.vue")
    },    
    {
      path: "/PartnerPlans/:id",
      name: "PartnerPlans",
      beforeEnter: (to, from, next) => {
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }

        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        else next();
      },
      component: () => import("./Partnerships/PartnerPlans/PartnerPlans.vue")
    },
    {
      path: "/PartnerPlansUpload/:id",
      name: "PartnerPlans",
      beforeEnter: (to, from, next) => {
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        }
        else {
          isAuthenticated = false;
        }

        if (!isAuthenticated) next("/login")
        else next()

      },
      component: () => import("./Partnerships/PartnerClientUpload/PartnerClientUpload.vue")
    },
    {
      path: "/manage-company/:id/:name",
      name: "manage-company",
      beforeEnter: (to, from, next) => {
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }

        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        else next();
      },
      component: () => import("./ManageCompany/ManageCompany.vue")
    },
    {
      path: "/back-office-orizon",
      name: "back-office-orizon",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        if (hasPermission) next();
        else next("/forbidden");
      },
      component: () => import("./BackOffice/Orizon/Orizon.vue")
    },
    {
      path: "/back-office-cards",
      name: "back-office-cards",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        if (hasPermission) next();
        else next("/forbidden");
      },
      component: () => import("./BackOffice/Cards/Cards.vue")
    },
    {
      path: "/customers-without-first-access",
      name: "customers-without-first-access",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        if (hasPermission) next();
        else next("/forbidden");
      },
      component: () =>
        import("./CustomersWithoutFirstAccess/CustomersWithoutFirstAccess.vue")
    },
    {
      path: "/unified-business-report",
      name: "unified-business-report",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        if (hasPermission) next();
        else next();
      },
      component: () =>
        import("./UnifiedBusinessReport/UnifiedBusinessReport.vue")
    },
    {
      path: "/health-plan-transfer",
      name: "health-plan-transfer",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated) next("/pages/login");
        if (hasPermission) next();
        else next("/forbidden");
      },
      component: () => import("./HealthPlanTransfer/HealthPlanTransfer.vue")
    },
    {
      path: "/quicksight-commercial-dashboard",
      name: "quicksight-commercial-dashboard",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        if (hasPermission) next();
        else next("/forbidden");
      },
      component: () => import("./QuicksightCommercial/QuicksightCommercial.vue")
    },
    {
      path: "/inactive-employees-report",
      name: "inactive-employees-report",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        if (hasPermission) next();
        else next("/forbidden");
      },
      component: () =>
        import("./InactiveEmployeesReport/InactiveEmployeesReport.vue")
    },
    {
      path: "/customers-commercial-report",
      name: "customers-commercial-report",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        if (hasPermission) next();
        else next("/forbidden");
      },
      component: () =>
        import("./CustomersCommercialReport/CustomersCommercialReport.vue")
    },
    {
      path: "/b2c-plans",
      name: "b2c-plans",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        if (hasPermission) next();
        else next("/forbidden");
      },
      component: () => import("./B2CPlans/B2CPlans.vue")
    },
    {
      path: "/specialties-management",
      name: "SpecialtiesManagement",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path)
        const bearer = Vue.prototype.$session.get("bearer")
        const isProjectPlan = !!Vue.prototype.$session.get("isProject")

        Vue.prototype.$session.set("bearer", Vue.prototype.$session.get("bearerDefault"));

        if (!bearer) {
          if (isProjectPlan) {
            next("/pages/login-horas")
          } else {
            next("/pages/login")
          }
        } else if (!hasPermission) {
          next("/forbidden")
        } else {
          next()
        }
      },
      component: () => import("./SpecialtiesManagement/SpecialtiesManagement.vue")
    },
    {
      path: "/all-campaigns",
      name: "all-campaigns",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        if (hasPermission) next();
        else next("/forbidden");
      },
      component: () => import("./Campaigns/Campaigns.vue")
    },
    {
      path: "/aas-registered-agents",
      name: "aas-registered-agents",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        if (hasPermission) next();
        else next("/forbidden");
      },
      component: () => import("./AAS/RegisteredAgents/RegisteredAgents.vue")
    },
    {
      path: "/aas-new-agents",
      name: "aas-new-agents",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        if (hasPermission) next();
        else next("/forbidden");
      },
      component: () => import("./AAS/Agent/Agent.vue")
    },
    {
      path: "/aas-coupon-association",
      name: "aas-coupon-association",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        if (hasPermission) next();
        else next("/forbidden");
      },
      component: () => import("./AAS/CouponAssociation/CouponAssociation.vue")
    },
    {
      path: "/register-plan-package",
      name: "register-plan-package",
      beforeEnter: (to, from, next) => {
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }

        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        else next();
      },
      component: () =>
        import("./Register/RegisterPlanPackage/RegisterPlanPackage.vue")
    },
    {
      path: "/register-plan-service",
      name: "register-plan-service",
      beforeEnter: (to, from, next) => {
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }

        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        else next();
      },
      component: () =>
        import("./Register/RegisterPlanService/RegisterPlanService.vue")
    },
    {
      path: "/external-provider",
      name: "external-provider",
      beforeEnter: (to, from, next) => {
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }

        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        else next();
      },
      component: () =>
        import("./Register/ExternalProvider/ExternalProvider.vue")
    },
    {
      path: "/external-provider-token",
      name: "external-provider-token",
      beforeEnter: (to, from, next) => {
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }

        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        else next();
      },
      component: () =>
        import("./Register/ExternalProviderToken/ExternalProviderToken.vue")
    },
    {
      path: "/associate-service-package",
      name: "associate-service-package",
      beforeEnter: (to, from, next) => {
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }

        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        else next();
      },
      component: () =>
        import("./Register/AssociateServicePackage/AssociateServicePackage.vue")
    },
    {
      path: "/natural-person-customers",
      name: "natural-person-customers",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        if (hasPermission) next();
        else next("/forbidden");
      },
      component: () =>
        import(
          "../Commercial/NaturalPersonCustomers/NaturalPersonCustomers.vue"
        )
    },
    {
      path: "/pending-subscriptions-report",
      name: "pending-subscriptions-report",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated) next("/pages/login");
        if (hasPermission) next();
        else next("/forbidden");
      },
      component: () =>
        import(
          "../Commercial/PendingSubscriptionsReport/PendingSubscriptionsReport.vue"
        )
    },
    {
      path: "/advertising-message",
      name: "advertising-message",
      beforeEnter: (to, from, next) => {
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }

        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        else next();
      },
      component: () =>
        import("./Register/AdvertisingMessage/AdvertisingMessage.vue")
    },
    {
      path: "/expired-invoices",
      name: "expired-invoices",
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem("systems").includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        const isProjectPlan = Vue.prototype.$session.get("isProject")
          ? Vue.prototype.$session.get("isProject")
          : false;
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated)
          if (isProjectPlan) next("/pages/login-horas");
          else next("/pages/login");
        if (hasPermission) next();
        else next("/forbidden");
      },
      component: () =>
        import("../Commercial/ExpiredInvoices/ExpiredInvoices.vue")
    }
  ]
};
export default [routes];
